import React, { Component } from "react";
import Zmage from "react-zmage";
import Fade from "react-reveal";
import "./style.css";

let id = 0;
class Portfolio extends Component {
  render() {
    if (!this.props.data) return null;

    const projects = this.props.data.projects.map(function (projects) {
      let projectImage = "images/" + projects.image;

      return (
        <div key={id++} className="columns portfolio-item">
          <div className="item-wrap">
            <Zmage alt={projects.title} src={projectImage} />
            {/* <div style={{ textAlign: "center" }}>{projects.title}</div> */}
          </div>
        </div>
      );
    });

    return (
      <div id="gallery">
        <h1 style={{ color: "rgba(255, 238, 0, 1)", textAlign: "center" }}>
          Gallery
        </h1>
        <section>
          <Fade left duration={1000} distance="40px">
            <div className="row">
              <div className="twelve columns collapsed">
                <div
                  id="portfolio-wrapper"
                  className="bgrid-quarters s-bgrid-thirds cf"
                >
                  {projects}
                </div>
              </div>
            </div>
          </Fade>
        </section>
      </div>
    );
  }
}

export default Portfolio;
